const SUPPORT_EMAIL_ADDRESS = process.env.SUPPORT_EMAIL_ADDRESS;
const SUPPORT_DOMAIN = "cyara.com";

export { SUPPORT_EMAIL_ADDRESS, SUPPORT_DOMAIN };
